module.exports = __webpack_public_path__ + "img/logo_noloolvides.4eb8030d.png";